import { Injectable } from "@angular/core";
import { UtilHandlerService } from "../handlers/util-handler.service";
import { SessionService } from "../session.service";
import moment from "moment-timezone";

const NUMBERS_COMMA_REGEX = /(\\d)(?=(\\d{3})+$)/;

export function addCommasToNumber(num: string | number): string {
  const numString = num.toString();

  return numString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function shortenNumber(num: number): string {
  if (Math.abs(num) > 999999) {
    return (
      Math.sign(num) * Number.parseInt((Math.abs(num) / 1000000).toFixed(1)) +
      "m"
    );
  } else if (Math.abs(num) > 999) {
    return (
      Math.sign(num) * Number.parseInt((Math.abs(num) / 1000).toFixed(1)) + "k"
    );
  }

  return num.toString();
}

@Injectable({
  providedIn: "root",
})
export class UtilService {
  constructor(
    private utilHandlerService: UtilHandlerService,
    private sessionSvc: SessionService,
  ) {}

  isValidHttpUrl(str: string) {
    let url;
    
    try {
      url = new URL(str);
    } catch (_) {
      return false;  
    }
  
    return url.protocol === "http:" || url.protocol === "https:";
  }

  formatDate(date: Date, format?: string): string {
    return moment(date).tz(this.sessionSvc.currentUserValue!.timezone).format(format !== undefined ? format : "MMM DD YYYY HH:mm z")
  }

  getTags(masterAccountID: number) {
    return this.utilHandlerService.tagsGet(masterAccountID);
  }

  formatPermissionBreakdown(data: any) {
    let color = "#CCC";

    switch (data.id) {
      // Unknown
      case 0:
        color = "#9270A3";
        break;
      // Restricted
      case 1:
        color = "#FF9226";
        break;
      // Denied
      case 2:
        color = "#A00000";
        break;
      // Always
      case 3:
        color = "#A1C700";
        break;
      // When In Use
      case 4:
        color = "#7DC4FD";
        break;
    }

    return {
      value: data.count,
      name: data.label,
      label: {
        color: "#FFF",
      },
      itemStyle: {
        color,
      },
    };
  }

}
